import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

import Spinner from '../Spinner'

interface IPaginateProps {
    dataLength: number;
    next: () => void;
    hasMore: boolean;
    loading: boolean;
    loadDark?: boolean
    endMessage: React.ReactNode
}

const Paginate: React.FC<IPaginateProps> = ({ dataLength, hasMore, next, loading, endMessage, loadDark, children }) => (
    <InfiniteScroll
        dataLength={dataLength}
        hasMore={hasMore}
        next={next}
        loader={loading && <Spinner modeDark={loadDark}/>}
        endMessage={!loading && endMessage}
    >
        {children}

    </InfiniteScroll>
) 


export default Paginate